module.exports = __webpack_public_path__ + "img/mobilecontactBanner.bc2d395c.png";